import { Injectable } from '@angular/core';
import { Router, CanLoad, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication/authentication.service';
// import { Logger } from '@app/core/logger.service';

// const logger = new Logger('VIPGuard');

@Injectable()
export class VipMemberGuard implements CanActivate, CanLoad {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  canLoad(): boolean {
    const user = this.authenticationService.userInfo;
    if (this.authenticationService.isAuthenticated() && user) {
      if (user.vip === true) {
        return true;
      }
    }

    // logger.info('VIP only area, redirecting...');
    this.router.navigate(['/home'], { replaceUrl: true });
    return false;
  }

  canActivate(): boolean {
    const user = this.authenticationService.userInfo;
    if (this.authenticationService.isAuthenticated() && user) {
      if (user.vip === true) {
        return true;
      }
    }

    // logger.info('VIP only area, redirecting...');
    this.router.navigate(['/home'], { replaceUrl: true });
    return false;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/vip-member.guard.ts